export default __webpack_public_path__ + "static/9-8fd5f6b759ba2a40f89ed55483e8984a.jpg";